import { Sort } from '@material-ui/icons';
import moment from 'moment';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Row, Col, Modal, ModalBody, ModalHeader } from 'reactstrap';
import Input from 'reactstrap/lib/Input';
import InputGroup from 'reactstrap/lib/InputGroup';
import Spinner from 'reactstrap/lib/Spinner';
import { EntityListContainer } from '../../../container/EntityListContainer';
import sort from 'fast-sort'
import { addItem } from '../../../core/database/firebaseFunctions';

export const sendNotification = (title, description, image = undefined, extraData = {}) => {
	let headers = {
		"Content-Type": "application/json; charset=utf-8",
		Authorization: "Basic 'YjY2MGQ2ZDQtMGU1Ni00ZDg5LWI0NzUtMjk0YmYxYjg0NjQw'"
	};

	const contents = { en: description, pt: description }

	let endpoint = "https://onesignal.com/api/v1/notifications";
	let params = {
		method: "POST",
		headers: headers,
		body: JSON.stringify({
			app_id: "7bed91b1-dbf6-414a-a536-33514e5357da",
			// filters: filters,
			data: extraData,
			headings: { en: title, pt: title },
			// subtitle: { en: title, pt: title },
			contents: contents,
			large_icon: "ic_launcher_round",
			small_icon: "ic_stat_onesignal_default",
			android_accent_color: "2D3192",
			ios_badgeType: "Increase",
			ios_badgeCount: 1,
			big_picture: image,
			ios_attachments: image,
			included_segments: ["Active Users", "Inactive Users"]
			// include_player_ids: [userId]
		})
	};
	fetch(endpoint, params).then(res => res && res.json()).then(res => console.log(res));
};

const PushForm = ({ onChange, setOpenModal }) => {
	const [values, setValues] = useState({})
	const [loading, setLoading] = useState(false)

	const generate = async () => {
		setLoading(true)
		if (values.title && values.description) {
			await addItem("Push", {
				title: values.title,
				description: values.description,
				image: values.image || "",
				date: moment().format("DD/MM/YYYY HH:mm"),
				time: new Date()
			})
			sendNotification(values.title, values.description, values.image || undefined)
			setValues({});
			onChange();
			setLoading(false)
			setOpenModal(false)
			toast.success("Enviado!")
		} else {
			toast.error("Título e descrição são obrigatórios!")
		}
	}

	const permissionsImage = (e) => {
		if (e && e.target && e.target.value) {
			var extPermitidas = ['jpg', 'png', 'gif', 'pdf', 'txt', 'doc', 'docx', ''];
			var extArquivo = e.target.value.split('.').pop();
			console.log({ extArquivo })
			if (typeof extPermitidas.find(function (ext) { return extArquivo == ext; }) == 'undefined') {
				toast.error('Link invalido');
			} else {
				console.log('Ok!');
				setValues({ ...values, image: e.target.value })
			}
		}
	}

	return (
		<>
			{loading ? <div className="loading" style={{ textAlign: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center', margin: 120 }}>
				<Spinner color="warning" style={{ marginBottom: 15 }} />
				<span>Aguarde enquanto geramos seu push</span>
			</div> :
				<Row className="push-form-row">
					<Row className="push-form">
						<Col>
							<label className="label-input">Título</label>
							<InputGroup>
								<Input className="input-qrcode"
									placeholder="Insira um título"
									type="text"
									onChange={(e) => setValues({ ...values, title: e.target.value })}
								/>
							</InputGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<label className="label-input">Descrição</label>
							<InputGroup>
								<Input
									placeholder="Insira uma descrição"
									type="text"
									onChange={(e) => setValues({ ...values, description: e.target.value })}
								/>
							</InputGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<label className="label-input">Imagem</label>
							<InputGroup>
								<Input
									placeholder="Insira o link da imagem"
									type="text"
									onChange={(e) => permissionsImage(e)}
								/>
							</InputGroup>
						</Col>
					</Row>
					<div className="btn-generate">
						<Button
							className="btn-generate-push"
							color="primary"
							onClick={generate}
						>
							Enviar Push
						</Button>
					</div>
				</Row>}
		</>
	)
}

const defaultColumns = () => {

	return [
		{
			title: 'Título',
			field: 'time',
			editable: true,
			defaultSort: 'desc',
			render: rowData => (
				<Row className="row-user" title={rowData.description}>
					<Col className="details truncated">
						{rowData.title} <br />
						{rowData.date}
					</Col>
				</Row>
			),
		},
	]
}

const PushScreen = ({loading, setLoading}) => {
	const [reload, setReload] = useState();
	return <div className="content push-page">
		<div className="push-header">
			<div className="push-page-tile">Push</div>
			<ModalAddPush onChange={() => setReload(!reload)} />
		</div>
		{/* <Card className="card-qrcode">
			<CardHeader>
				<CardHeader className="card-qrcode-header">
					<span>Informe uma ou mais referências para gerar o QR code. Ex: COD 405 ao COD 423.</span>
				</CardHeader>
			</CardHeader>
			<CardBody>
				<PushForm onChange={() => setReload(!reload)} />
			</CardBody>
		</Card> */}
		<div className="push-page-subtitle">Histórico de push</div>
		<div className="table-historic-push">
			<EntityListContainer
				columns={defaultColumns()}
				title=""
				tableName="Push"
				clause={{}}
				addClauseInItem={true}
				hasPower={false}
				// parentChildData={(row, rows) => rows.find(a => a.id === row.parent)}
				// onAddClick={() => {
				// 	setOpenModal(true)
				// }}
				// onEditClick={data => {
				// 	setOpenModal(data)
				// }}
				// onAddChildren={data => {
				// 	setOpenModal(true)
				// 	setParent(data)
				// }}
				// onDeleteClick={data => onDeleteClick(data)}
				// treeList={true}
				reload={reload}
			/>
		</div>
	</div>
}

const ModalAddPush = ({ onChange, }) => {
	const [openModal, setOpenModal] = useState(false)

	const toggle = () => setOpenModal(openModal => !openModal)

	return (
		<>
			<Button
				className="btn-add-push"
				onClick={toggle}
			>
				Adicionar Novo
			</Button>
			<Modal className="user-modal" isOpen={openModal !== false} toggle={toggle}>
				<ModalHeader className="title-modal" toggle={toggle}>{`Adicionar Push`}</ModalHeader>
				<ModalBody>
					<PushForm onChange={onChange} setOpenModal={setOpenModal} />
				</ModalBody>
			</Modal>
		</>
	)
}

export default PushScreen;